/* eslint-disable prettier/prettier */
import { Suspense, useCallback, useEffect, useState } from "react";
import { NotificationsProps } from "../../../@types/components/notifications.types";
import { NotificationIconType, TabName } from "../../../@types/notifications.types";
import { Tabs, Tab, ListItem, ListItemAvatar, ListItemText, Box, List } from "@material-ui/core";

import { NOTIFICATION_TABS } from "../../../constants/notification/notificationTabs";
import { NOTIFICATION_ICON_TYPE } from "../../../constants/notification/notificationIconType";
import { LazyNotification } from "..";
import { FaVolumeMute, FaVolumeUp } from "react-icons/fa";

import "./notifications.css";

import ROLES from "../../../constants/roles";
import { Skeleton } from "@material-ui/lab";
import useRouteParam from "../../../hooks/useRouteParam";

const Notifications = ({
	user,
	oldNotifications,
	newNotifications,
	scrollEvent,
	skeletonLoad,
	loading
}: NotificationsProps): JSX.Element => {
	const [tabName, setTabName] = useState<TabName>("all");
	const [filteredNewNotifications, setFilteredNewNotifications] = useState<any[]>([]);
	const [filteredOldNotifications, setFilteredOldNotifications] = useState<any[]>([]);
	const queryGroupNumber = useRouteParam("gn");
	const [muteStatus, setMuteStatus] = useState<any>();
	// console.log("Notification User", user?.role);
	// console.log("Notification queryGroupNumber", queryGroupNumber);
	const seeAllRoute =
		user?.role === ROLES.employer ? `/employer/all-notifications?gn=${queryGroupNumber}` : "/all-notifications";
	// console.log("Notification See All Route", seeAllRoute);

	const filterNotifications = useCallback((notifications: any[], type: TabName) => {
		const filteredNotifications: any[] = [];
		notifications.forEach((notification: any) => {
			if (type === "all") {
				filteredNotifications.push(notification);
			} else if (notification.type === type) {
				filteredNotifications.push(notification);
			}
		});

		return filteredNotifications;
	}, []);

	const handleTabChange = useCallback(
		(_event: any, _tabName: TabName) => {
			setTabName(_tabName);
			const _filteredNewNotifications = filterNotifications(newNotifications, _tabName);
			const _filteredOldNotifications = filterNotifications(oldNotifications, _tabName);
			setFilteredNewNotifications(Object.assign([], _filteredNewNotifications));
			setFilteredOldNotifications(Object.assign([], _filteredOldNotifications));
		},
		[filterNotifications, newNotifications, oldNotifications]
	);

	const handleSetToMute = useCallback(() => {
		window.localStorage.setItem("MUTE_STATUS", "true");
		setMuteStatus("true");
	}, []);

	const handleSetToUnmute = useCallback(() => {
		window.localStorage.setItem("MUTE_STATUS", "false");
		setMuteStatus("false");
	}, []);

	useEffect(() => {
		const _filteredNewNotifications = filterNotifications(newNotifications, tabName);
		const _filteredOldNotifications = filterNotifications(oldNotifications, tabName);
		setFilteredNewNotifications(Object.assign([], _filteredNewNotifications));
		setFilteredOldNotifications(Object.assign([], _filteredOldNotifications));
	}, [filterNotifications, newNotifications, oldNotifications, tabName]);

	useEffect(() => {
		setMuteStatus(window.localStorage.getItem("MUTE_STATUS"));
	}, []);

	// console.log("muteStatus (State) ", muteStatus);

	return (
		<div className="notifications" onScroll={scrollEvent}>
			<div className="header">
				<span>Notifications</span>
				{/* MUTE STATUS TRUE & FALSE ON ONCLICK & GRAY:MUTE*/}
				{muteStatus === "true" && (
					<div onClick={handleSetToUnmute} className="muteIcon">
						<FaVolumeMute />
					</div>
				)}
				{/* MUTE STATUS FALSE & TRUE ON ONCLICK & GREEN:UNMUTE */}
				{muteStatus === "false" && (
					<div onClick={handleSetToMute} className="unmuteIcon">
						<FaVolumeUp />
					</div>
				)}
				<a href={seeAllRoute}>See all</a>
			</div>
			<Box sx={{ flexGrow: 1, bgcolor: "background.paper" }}>
				<Tabs
					value={tabName}
					onChange={handleTabChange}
					variant={NOTIFICATION_TABS.length < 6 ? "fullWidth" : "scrollable"}
					//ariant="scrollable"
					scrollButtons="auto"
					centered
					TabIndicatorProps={{
						style: {
							backgroundColor: "#AED580"
						}
					}}
					textColor="primary"
				>
					{NOTIFICATION_TABS.map((tab, index) => (
						<Tab
							key={index}
							style={{
								color: tabName === tab.value ? "#AED580" : "inherit",
								fontSize: "14px",
								fontFamily: "Quicksand",
								minWidth: "20%"
							}}
							label={tab.label}
							icon={<i className={NOTIFICATION_ICON_TYPE[tab.value as keyof NotificationIconType]}></i>}
							value={tab.value}
						/>
					))}
					;
				</Tabs>
			</Box>
			<List>
				<>
					{filteredNewNotifications.length > 0 ? <b>New</b> : ""}
					{filteredNewNotifications
						? filteredNewNotifications.map((filteredNewNotification, index) => {
								return (
									<Suspense key={index}>
										<LazyNotification notification={filteredNewNotification} />
									</Suspense>
								);
						  })
						: ""}
					{filteredNewNotifications.length > 0 && filteredOldNotifications.length ? <b>Earlier</b> : ""}
					{filteredOldNotifications
						? filteredOldNotifications.map((filteredOldNotification, index) => {
								return (
									<Suspense key={index}>
										<LazyNotification notification={filteredOldNotification} />
									</Suspense>
								);
						  })
						: ""}
					{loading.current && skeletonLoad ? (
						<div className="skeleton-container">
							<div className="loading-skeleton">
								<ListItem>
									<ListItemAvatar>
										<Skeleton animation="wave" width={40} height={40} />
									</ListItemAvatar>
									<ListItemText
										className="list-item-text"
										primary={
											<Skeleton
												animation="wave"
												height={10}
												width="95%"
												style={{ marginBottom: 6 }}
											/>
										}
										secondary={<Skeleton animation="wave" height={10} width="30%" />}
									/>
								</ListItem>
							</div>
							<div className="loading-skeleton">
								<ListItem>
									<ListItemAvatar>
										<Skeleton animation="wave" width={40} height={40} />
									</ListItemAvatar>
									<ListItemText
										className="list-item-text"
										primary={
											<Skeleton
												animation="wave"
												height={10}
												width="95%"
												style={{ marginBottom: 6 }}
											/>
										}
										secondary={<Skeleton animation="wave" height={10} width="30%" />}
									/>
								</ListItem>
							</div>
						</div>
					) : (
						""
					)}
				</>
			</List>
		</div>
	);
};

export default Notifications;
